import { render, staticRenderFns } from "./SkipToContent.vue?vue&type=template&id=ca3ba194&scoped=true"
import script from "./SkipToContent.vue?vue&type=script&lang=ts"
export * from "./SkipToContent.vue?vue&type=script&lang=ts"
import style0 from "./SkipToContent.vue?vue&type=style&index=0&id=ca3ba194&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3ba194",
  null
  
)

export default component.exports